import React from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";
import { LOGO_URL } from "../lib/theme";

export default function Login() {
  const { user, signIn, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  return (
    <div style={{ minHeight: "100vh", background: "#1C191B", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} data-testid="login-screen">
      <div style={{ position: "absolute", inset: 0, background: "radial-gradient(at 30% 20%, rgba(62,24,55,0.6), transparent 60%), radial-gradient(at 80% 70%, rgba(203,163,181,0.18), transparent 50%)" }} />
      <div style={{ position: "relative", width: "100%", maxWidth: 460 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: "#fff", overflow: "hidden", display: "grid", placeItems: "center" }}>
            <img src={LOGO_URL} alt="logo" style={{ width: 56, height: 56, objectFit: "cover" }} />
          </div>
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: -0.4 }}>Studio Grape</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.65)" }}>Garment Manufacturing Studio</div>
          </div>
        </div>

        <div style={{ background: "#fff", color: "var(--ink)", borderRadius: 20, padding: 30 }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, letterSpacing: -0.6, margin: 0 }}>Welcome back</h2>
          <p style={{ fontSize: 14, color: "var(--muted)", marginTop: 8, marginBottom: 26, lineHeight: 1.5 }}>
            Sign in to manage onboarding, meetings, sampling &amp; production quotes.
          </p>
          <button
            data-testid="google-signin-button"
            onClick={signIn}
            style={{
              width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
              padding: "14px", border: "1px solid var(--line)", background: "#fff", borderRadius: 10,
              fontSize: 14, fontWeight: 700, cursor: "pointer",
            }}
          >
            <GoogleIcon />
            <span>Continue with Google</span>
          </button>
          <p style={{ fontSize: 11, color: "var(--muted)", marginTop: 16, textAlign: "center" }}>
            By continuing you agree to Studio Grape's terms &amp; privacy policy.
          </p>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/><path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/><path fill="#FBBC04" d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"/><path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.92 4.18 29.94 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7C13.42 14.62 18.27 10.75 24 10.75z"/></svg>
  );
}
